<template>
  <AppTimeZoneDropdown
    :active="activeTimeZone"
    :options="timeZoneOptions"
    :tooltip-options="tooltipOptions"
    :direction="direction"
    @input="changeTimeZone"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import AppTimeZoneDropdown from '~/components/AppTimeZoneDropdown.vue';

export default {
  name: 'InsightsHeaderTimeZoneFilter',
  components: { AppTimeZoneDropdown },
  props: {
    direction: {
      type: String,
      default: 'left',
    },
  },
  // Must be declared: without it the parent's @input listener falls through via $attrs onto the
  // root element, where bubbling native input events would invoke it with a DOM Event.
  emits: ['input'],
  data: () => ({
    tooltipOptions: Object.freeze({ container: 'body' }),
  }),
  computed: {
    ...mapGetters(['activeTimeZone', 'timeZoneOptions']),
  },
  methods: {
    changeTimeZone(tzParam, _description, kind) {
      this.$emit('input', tzParam, kind);
    },
  },
};
</script>
